export function InfoRow({
  icon: Icon,
  label,
  value,
}: { icon: React.ComponentType<{ className?: string }>; label: string; value: string }) {
  return (
    <div className="flex items-start gap-2">
      <Icon className="size-4 text-muted-foreground flex-shrink-0" />
      <div className="flex-1">
        <div className="text-xs text-muted-foreground mb-1">{label}</div>
        <div className="font-medium text-foreground break-words">{value}</div>
      </div>
    </div>
  );
}
